function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("circle", {
  cx: 30,
  cy: 30,
  r: 29,
  stroke: "#4C9493",
  strokeLinecap: "round",
  strokeDasharray: "5 5"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M30 53c12.703 0 23-10.297 23-23S42.703 7 30 7 7 17.297 7 30s10.297 23 23 23z",
  fill: "#4C9493"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M28.36 24.6l-2.66 2.46-1.4-1.66 4.28-3.56h2.18V36h-2.4V24.6z",
  fill: "#fff"
});

var SvgStepItem1 = function SvgStepItem1(props) {
  return React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none"
  }, props), _ref, _ref2, _ref3);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48Y2lyY2xlIGN4PSIzMCIgY3k9IjMwIiByPSIyOSIgc3Ryb2tlPSIjNEM5NDkzIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1kYXNoYXJyYXk9IjUgNSIvPjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMzAgNTNjMTIuNzAzIDAgMjMtMTAuMjk3IDIzLTIzUzQyLjcwMyA3IDMwIDcgNyAxNy4yOTcgNyAzMHMxMC4yOTcgMjMgMjMgMjN6IiBmaWxsPSIjNEM5NDkzIi8+PHBhdGggZD0iTTI4LjM2IDI0LjZsLTIuNjYgMi40Ni0xLjQtMS42NiA0LjI4LTMuNTZoMi4xOFYzNmgtMi40VjI0LjZ6IiBmaWxsPSIjZmZmIi8+PC9zdmc+";
export { SvgStepItem1 as ReactComponent };